// Should be kept in sync wih backend EMBARGOED_COUNTRY_CODES setting.
export const EMBARGOED_COUNTRY_CODES = [
    'CU',     // Cuba
    'IR',     // Iran
    'KP',    // North Korea
];
